import script from "./MFI.vue?vue&type=script&lang=js"
export * from "./MFI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__